import React from "react";
import ReactEcharts from "echarts-for-react";

// Function to calculate the linear regression (y = mx + b)
const getLinearTrend = (data) => {
  const n = data.length;
  const x = Array.from({ length: n }, (_, i) => i + 1); // Index as x-axis values
  const y = data;

  // Calculate the sum of x, y, x^2, and xy
  const sumX = x.reduce((acc, val) => acc + val, 0);
  const sumY = y.reduce((acc, val) => acc + val, 0);
  const sumXY = x.reduce((acc, val, idx) => acc + val * y[idx], 0);
  const sumX2 = x.reduce((acc, val) => acc + val * val, 0);

  // Calculate the slope (m) and intercept (b)
  const m = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
  const b = (sumY - m * sumX) / n;

  // Calculate the trend line values (y = mx + b) for each x
  const trendLine = x.map((val) => m * val + b);
  return trendLine;
};

const WorkingCapitalChart = () => {
  const dates = [
    "01-07-2020", "01-09-2020", "01-11-2020", "01-01-2021", "01-03-2021", "01-05-2021", "01-07-2021",
    "01-09-2021", "01-11-2021", "01-01-2022", "01-03-2022", "01-05-2022", "01-07-2022", "01-09-2022",
    "01-11-2022", "01-01-2023", "01-03-2023"
  ];

  const daysOutstandingData = [
    22.78, 16.68, 23.56, 35.72, 41.02, 28.96, 35.65, 28.81, 21.40, 30.61, 25.47, 17.71,
    29.31, 23.07, 21.34, 22.41, 3.35
  ];

  // Calculate trend line for days outstanding
  const daysOutstandingTrend = getLinearTrend(daysOutstandingData);

  const option = {
    tooltip: { trigger: "axis" },
    legend: { data: ["Days Outstanding", "Trend Line"] },
    xAxis: {
      type: "category",
      data: dates,
      axisLabel: {
        rotate: 45, // Rotate labels to fit better
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: "{value}",
      },
    },
    series: [
      {
        name: "Days Outstanding",
        type: "line",
        data: daysOutstandingData,
        smooth: true,
        lineStyle: { color: "blue" },
        markPoint: {
          data: [{ type: "max", name: "Max Value" }, { type: "min", name: "Min Value" }],
        },
      },
      {
        name: "Trend Line",
        type: "line",
        data: daysOutstandingTrend,
        smooth: true,
        lineStyle: { color: "red", type: "dashed" }, // Dashed line for trend
      },
    ],
  };

  return <ReactEcharts option={option} style={{ height: "500px" }} />;
};

export default WorkingCapitalChart;
